











import { Component, Vue, Prop } from 'vue-property-decorator';

// eslint-disable-next-line no-unused-vars
import { StatementType } from '@/types/services';
// eslint-disable-next-line no-unused-vars
import { IAdditionalStatements } from '@/utils/types';
import { AdditionalDocumentsType } from '@/types/alternativeServices';
import { RouteName } from '@/router';
import { isEnvAddDocumentsEnable } from '@/app.config';

@Component({})
export default class AltDocumentsPaymentButton extends Vue {
  @Prop({ default: () => [] }) additionalStatements!: IAdditionalStatements[];
  @Prop({ default: null }) statusParent!: string;
  @Prop() statementType!: StatementType;
  @Prop({ default: false }) wasPaid!: boolean;
  private showAdditionalDocumentsPaymentButton: boolean = false;
  private additionalDocumentsPayment!: IAdditionalStatements;
  private statusesDocumentsPayment: string[] = [
    'IN_PROGRESS',
    'SUSPENDED_AWAITING_DOCUMENTS',
    'SUSPENDED_DOCUMENTS_PROVIDED',
    'AWAITING_PAYMENT',
    'PAID',
  ];

  mounted() {
    this.additionalStatements.forEach((item: IAdditionalStatements) => {
      if (
        item.type === AdditionalDocumentsType.ADD_QUITTANCES &&
        ['DRAFT'].includes(item.status) &&
        this.statusesDocumentsPayment.includes(this.statusParent) &&
        !this.wasPaid
      ) {
        this.showAdditionalDocumentsPaymentButton =
          isEnvAddDocumentsEnable[this.statementType];
        this.additionalDocumentsPayment = { ...item };
      }
    });
  }

  goDopDocumentsPage(statement: IAdditionalStatements) {
    if (!statement) return;

    this.$router.push({
      name: RouteName.ADD_DOCUMENTS_APPLICANT,
      params: { altStatementId: statement.id },
    });
  }
}
